import React from 'react';
import { AuthorisationItem } from 'types';
type Props = {
  authorisation?: AuthorisationItem;
};

const DetailsTable: React.FC<Props> = ({ authorisation }) => {
  return (
    <div className="authorisation-details-table">
      <table>
        <tbody>
          <tr>
            <td className="label">Channel</td>
            <td className="value">{authorisation?.channel}</td>
          </tr>
          <tr>
            <td className="label">BYDA member</td>
            <td className="value">
              {authorisation?.externalId ? 'Yes' : 'No'}
            </td>
          </tr>
          {authorisation?.externalId && (
            <tr>
              <td className="label">BYDA ID</td>
              <td className="value">{authorisation.externalId || '-'}</td>
            </tr>
          )}
          <tr>
            <td className="label">Primary contact name</td>
            <td className="value">
              {authorisation?.primaryContactName || '-'}
            </td>
          </tr>
          <tr>
            <td className="label">Primary contact email</td>
            <td className="value">
              {authorisation?.primaryContactEmail || '-'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(DetailsTable);
